import { styled } from '@mui/material/styles'
import logo from '../../../../assets/img/logo.svg'
import { theme } from '../../../../modules/App/Providers/Theme/theme'

const Container = styled('header')`
  align-items: center;
  background-color: ${theme.palette.primary.main};
  display: grid;
  min-height: 3.25rem;
  padding: 1rem;
`

const Header = () => (
  <Container>
    <img src={logo} />
  </Container>
)

export { Header }
